<div class="container mb-3">
  <div class="row header  bg-white">
    <div class="col text-center cursor " [ngClass]="{'border-bottom-blue': upcomingOrders}"
      (click)="onOrderTypeClick('UPCOMING_ORDERS')">
      <label class="m-3 font-weight-bold card-title">Upcoming Orders</label>
    </div>
    <div class="col text-center cursor" [ngClass]="{'border-bottom-blue': pastOrders}"
      (click)="onOrderTypeClick('PAST_ORDERS')">
      <label class="m-3 font-weight-bold card-title">Past Orders</label>
    </div>
  </div>
</div>
<div class="content-orders bg-white">
  <div *ngIf="upcomingOrders">
    <div class="row" *ngIf="upcomingOrderList.length === 0">
      <div class="col text-center">
        <label for="" class="text-danger">No upcoming orders</label>
      </div>
    </div>
    <div class="row" *ngFor="let order of upcomingOrderList">
      <div class="col">
        <div class="card border-0 border-bottom-grey mb-3 border-radius-0">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-3 pr-0">
                <img  class="card-img web-orders-img-location" [lazyLoad]="order.imagePath" [defaultImage]="defaultImage" alt="Card image">
              </div>
              <div class="col-6 line-height-1">
                <label class="card-title font-weight-bold mt-1 mb-1">{{order.companyName}}</label> <br />
                <small class="text-dark">{{order.locationName}}</small><br />
                <br />
              </div>
              <div class="col-3 pl-0 text-right">
                <label><span class="badge btn-block badge-secondary cursor font-size-90 p-1"
                    (click)="onActionClick('VIEW_RECEIPT',receipt,order)"><span
                      class="small">Receipt</span></span></label>
                <br />
                <label><span class="badge btn-block badge-secondary cursor font-size-90 p-1 pl-2 pr-2 "
                    (click)="onViewStatusClick(order)"><span class="small">Status</span></span></label>
              </div>
            </div>
            <div>
              <div class="row no-gutters mb-0 line-height-1">
                <div class="col">
                  <label class="text-dark mb-0">order #{{order.saleOrder.sales_order_number}} <span
                      class="text-dark fa-xs-small-70">dated {{order.date}}</span></label>
                </div>
              </div>
              <div class="row no-gutters mb-1">
                <div class="col">
                  <small class="text-dark">{{order.serviceType}} by {{order.date}}</small>
                </div>
              </div>
              <div class="row no-gutters small" [ngClass]="{'mt-2': i === 0}"
                *ngFor="let item of order.saleOrder.orderItems;let i=index;">
                <div class="col-1">
                  <label for="">{{item.count}}</label>
                </div>
                <div class="col-8 line-height-1 mb-1">
                  <label class="text-truncate font-weight-bold mb-1">
                    {{item.itemName}}
                  </label>
                  <p class="text-muted text-break  mb-0 font-size-90">
                    {{item.variant[0].variantName}}
                  </p>
                  <p class="text-muted text-break mb-0 font-size-90" *ngFor="let modset of item.modifierset">
                    <small>{{modset.somm_modifier_name}} - </small>
                    <span *ngFor="let modifier of modset.modifierOption;let optionindex=index;">
                      <small *ngIf="modifier.sommo_quantity > 0">
                        {{modifier.sommo_option_name}}<span
                          *ngIf="optionindex !== modset.modifierOption.length - 1">,</span>
                      </small>
                    </span>
                  </p>

                </div>
                <div class="col-3 text-right">
                  <label for="">{{item.totalPrice.toFixed(2)}}</label>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">Sub Total</span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.saleOrder.orderSubTotal.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">Order Discount</span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.orderDiscount.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>

              <div class="row" *ngIf="order.listcashback">
                <div class="col">
                  <div *ngFor="let discount of order.listcashback">
                    <div class="row no-gutters" *ngIf="discount.ooocd_type === 'REFERRAL_DISCOUNT'">
                      <div class="col text-right">
                        <span for="" class="fa-xs-small-70 font-weight-bold-500">
                          {{discount.ooocd_mod_name}}
                          <span *ngIf="discount.ooocd_percentage > 0">
                            ({{discount.ooocd_percentage}}%)
                          </span>
                        </span>
                      </div>
                      <div class="col-3 text-right">
                        <span class="mb-0 fa-xs-small-70">
                          <small *ngIf="position === 'BACK'">
                            {{currency}}
                          </small>
                          -{{discount.ooocd_amount.toFixed(2)}}
                          <small *ngIf="position === 'FRONT'">
                            {{currency}}
                          </small>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              
              <div class="row no-gutters" *ngFor="let tax of order.ListOrderTax">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">
                    {{tax.TaxName}}
                  </span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{tax.TaxAmount.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>

              <div class="row no-gutters" *ngIf="order.orderServiceType === 'DINE_IN'">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">Surcharge <span *ngIf="order.surcharges">({{order.surcharges.sosur_surcharge_percentage}}%)</span></span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.saleOrder.surcharge.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>
              <div class="row no-gutters" *ngIf="order.orderServiceType === 'DELIVERY'">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">Delivery Charges</span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.saleOrder.delivery_charge.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>

              <div class="row" *ngIf="order.listcashback">
                <div class="col">
                  <div *ngFor="let discount of order.listcashback">
                    <div class="row no-gutters" *ngIf="discount.ooocd_type !== 'REFERRAL_DISCOUNT'">
                      <div class="col text-right">
                        <span for="" class="fa-xs-small-70 font-weight-bold-500">
                          {{discount.ooocd_mod_name}}
                          <span *ngIf="discount.ooocd_percentage > 0">
                            ({{discount.ooocd_percentage}}%)
                          </span>
                        </span>
                      </div>
                      <div class="col-3 text-right">
                        <span class="mb-0 fa-xs-small-70">
                          <small *ngIf="position === 'BACK'">
                            {{currency}}
                          </small>
                          -{{discount.ooocd_amount.toFixed(2)}}
                          <small *ngIf="position === 'FRONT'">
                            {{currency}}
                          </small>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-9 text-right">
                  <label for="" class="font-weight-bold">Total</label>
                </div>
                <div class="col text-right">
                  <label for="" class="font-weight-bold">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.ordertotalamount.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </label>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-9 text-right">
                  <label for="" class="font-weight-bold">Paid by {{order.paidby}}</label>
                </div>
                <div class="col text-right">
                  <label for="" class="font-weight-bold">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.ordertotalamount.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </label>
                </div>
              </div>

              

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="pastOrders">
    <div class="row" *ngIf="pastOrderList.length === 0">
      <div class="col text-center">
        <label for="" class="text-danger">No past orders</label>
      </div>
    </div>
    <div class="row" *ngFor="let order of pastOrderList">
      <div class="col">
        <div class="card border-0 border-bottom-grey mb-3 border-radius-0">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-3 pr-0">
                <img class="card-img web-orders-img-location" [lazyLoad]="order.imagePath" [defaultImage]="defaultImage" alt="Card image">
              </div>
              <div class="col-6 line-height-1">
                <label class="card-title font-weight-bold mt-1 mb-1">{{order.companyName}}</label> <br />
                <small class="text-dark">{{order.locationName}}</small><br />
                <br />
              </div>
              <div class="col-3 pl-0 text-right">
                <div class="btn-group" dropdown>
                  <button id="button-animated" dropdownToggle type="button"
                          class="btn btn-sm btn-outline-secondary dropdown-toggle box-shadow-none outline-0"
                          aria-controls="dropdown-animated">
                    <span class="small"> Actions <span class="caret"></span></span>
                  </button>
                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                      aria-labelledby="button-animated">
                    <li role="menuitem" class="cursor">
                      <a class="dropdown-item"
                         (click)="onActionClick('VIEW_RECEIPT',receipt,order)">
                        <span class="small">
                          View Receipt
                        </span>
                      </a>
                    </li>
                    <li role="menuitem" class="cursor"
                        *ngIf="!order.orderRating.ratingdone && order.orderstatus !== 'REJECT'">
                      <a class="dropdown-item"
                         (click)="onActionClick('RATE_TIPS',rating,order)"><span class="small">Rate </span></a>
                    </li>
                    <li role="menuitem" class="cursor" *ngIf="!qrCodeScanned">
                      <a class="dropdown-item"
                         (click)="onActionClick('RE_ORDER',receipt,order)"><span class="small">Re-Order</span></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <div class="row no-gutters mb-0 line-height-1">
                <div class="col">
                  <label class="text-dark mb-0">
                    order #{{order.saleOrder.sales_order_number}} <span class="text-dark fa-xs-small-70">dated {{order.date}}</span>
                  </label>
                </div>
              </div>
              <div class="row no-gutters mb-1">
                <div class="col">
                  <small class="text-dark">
                    {{order.serviceType}} by {{order.date}} 
                  </small>
                </div>
              </div>
              <div class="row no-gutters small" [ngClass]="{'mt-2': i === 0}"
                   *ngFor="let item of order.saleOrder.orderItems;let i=index;">
                <div class="col-1">
                  <label for="">{{item.count}}</label>
                </div>
                <div class="col-8 line-height-1 mb-1">
                  <label class="text-truncate font-weight-bold mb-1">
                    {{item.itemName}}
                  </label>
                  <p class="text-muted text-break  mb-0 font-size-90">
                    {{item.variant[0].variantName}}
                  </p>
                  <p class="text-muted text-break mb-0 font-size-90" *ngFor="let modset of item.modifierset">
                    <small>{{modset.somm_modifier_name}} - </small>
                    <span *ngFor="let modifier of modset.modifierOption;let optionindex=index;">
                      <small *ngIf="modifier.sommo_quantity > 0">
                        {{modifier.sommo_option_name}}<span *ngIf="optionindex !== modset.modifierOption.length - 1">,</span>
                      </small>
                    </span>
                  </p>
                </div>
                <div class="col-3 text-right">
                  <label for="">{{item.totalPrice.toFixed(2)}}</label>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">Sub Total</span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.saleOrder.orderSubTotal.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">Order Discount</span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.orderDiscount.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>
              
              <div class="row" *ngIf="order.listcashback">
                <div class="col">
                  <div *ngFor="let discount of order.listcashback">
                    <div class="row no-gutters" *ngIf="discount.ooocd_type === 'REFERRAL_DISCOUNT'">
                      <div class="col text-right">
                        <span for="" class="fa-xs-small-70 font-weight-bold-500">
                          {{discount.ooocd_mod_name}}
                          <span *ngIf="discount.ooocd_percentage > 0">
                            ({{discount.ooocd_percentage}}%)
                          </span>
                        </span>
                      </div>
                      <div class="col-3 text-right">
                        <span class="mb-0 fa-xs-small-70">
                          <small *ngIf="position === 'BACK'">
                            {{currency}}
                          </small>
                          -{{discount.ooocd_amount.toFixed(2)}}
                          <small *ngIf="position === 'FRONT'">
                            {{currency}}
                          </small>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              
              <div class="row no-gutters" *ngFor="let tax of order.ListOrderTax">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">
                    {{tax.TaxName}}
                  </span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{tax.TaxAmount.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>

              <div class="row no-gutters" *ngIf="order.orderServiceType === 'DINE_IN'">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">Surcharge<span *ngIf="order.surcharges">({{order.surcharges.sosur_surcharge_percentage}}%)</span></span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.saleOrder.surcharge.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>

              <div class="row no-gutters" *ngIf="order.orderServiceType === 'DELIVERY'">
                <div class="col-9 text-right">
                  <span for="" class="fa-xs-small-70">Delivery Charges</span>
                </div>
                <div class="col text-right">
                  <span for="" class="fa-xs-small-70">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.saleOrder.delivery_charge.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </span>
                </div>
              </div>

              <div class="row" *ngIf="order.listcashback">
                <div class="col">
                  <div *ngFor="let discount of order.listcashback">
                    <div class="row no-gutters" *ngIf="discount.ooocd_type !== 'REFERRAL_DISCOUNT'">
                      <div class="col text-right">
                        <span for="" class="fa-xs-small-70 font-weight-bold-500">
                          {{discount.ooocd_mod_name}}
                          <span *ngIf="discount.ooocd_percentage > 0">
                            ({{discount.ooocd_percentage}}%)
                          </span>
                        </span>
                      </div>
                      <div class="col-3 text-right">
                        <span class="mb-0 fa-xs-small-70">
                          <small *ngIf="position === 'BACK'">
                            {{currency}}
                          </small>
                          -{{discount.ooocd_amount.toFixed(2)}}
                          <small *ngIf="position === 'FRONT'">
                            {{currency}}
                          </small>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-9 text-right">
                  <label for="" class="font-weight-bold">Total</label>
                </div>
                <div class="col text-right">
                  <label for="" class="font-weight-bold">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.ordertotalamount.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </label>
                </div>
              </div>

              <div class="row no-gutters">
                <div class="col-9 text-right">
                  <label for="" class="font-weight-bold">Paid by {{order.paidby}}</label>
                </div>
                <div class="col text-right">
                  <label for="" class="font-weight-bold">
                    <small *ngIf="order.Position === 'BACK'">
                      {{order.Currency}}
                    </small>
                    {{order.ordertotalamount.toFixed(2)}}
                    <small *ngIf="order.Position === 'FRONT'">
                      {{order.Currency}}
                    </small>
                  </label>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-ecom-footer class="footer"></app-ecom-footer>

<ng-template #receipt>
  <div class="modal-header">
    <h6 class="modal-title pull-left">Invoice <span *ngIf="!selectedOrder.paymentstatus">(Unpaid)</span>
      <span *ngIf="selectedOrder.paymentstatus">(Paid)</span></h6>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pt-0">
    <div class="row border-bottom">
      <div class="col-2 text-center">
        <img *ngIf="selectedOrder.logopath" width="50px" height="50px" [lazyLoad]="selectedOrder.logopath" [defaultImage]="defaultImage" alt="Logo">
      </div>
      <div class="col">
        <div class="">
          <span class="font-weight-bold-500 h5 m-2 mt-3">{{selectedOrder.companyName}}</span>
        </div>
        <div>
          Business No - {{selectedOrder.CompanyBusinessNumber}}
        </div>
        <div>
          {{selectedOrder.locationAddress}}
        </div>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col"><span class="font-weight-bold-500">Tax Invoice :</span>
        {{selectedOrder.saleOrder.sales_order_id}}</div>
      <div class="col text-right"><span class="font-weight-bold-500">Order no :</span>
        {{selectedOrder.saleOrder.sales_order_number}}</div>
    </div>
    <div class="row border-bottom pb-2">
      <div class="col"><span class="font-weight-bold-500">Customer :</span> {{selectedOrder.userName}}</div>
      <div class="col text-right"><span class="font-weight-bold-500">Date :</span> {{selectedOrder.date}}</div>
    </div>
    <div class="row no-gutters py-2">
      <div class="col-7">
        <div>
          <span class="fw-500 font-weight-bold">Item</span>
        </div>
      </div>
      <div class="col-2">
        <span class="fw-500 font-weight-bold">Qty</span>
      </div>
      <div class="col-3 text-right">
        <span class="fw-500 font-weight-bold">Price</span>
      </div>
    </div>
    <div class="pt-3 pb-3  border-top">
      <div class="row no-gutters py-1" *ngFor="let item of selectedOrder.saleOrder.orderItems;let i=index;">
        <div class="col-7">
          <div class="text-truncate font-weight-bold-500 h6 mb-0">
            {{item.itemName}}
          </div>
          <p class="text-muted text-break font-color-light-grey mb-0" style="font-size: 12px;">
            {{item.variant[0].variantName}}
          </p>
          <p class="text-muted text-break font-color-light-grey mb-0 fa-xs-small-70"
            *ngFor="let modifierset of item.modifierset">
            <small>{{modifierset.somm_modifier_name}} - </small>
            <span *ngFor="let modifier of modifierset.modifierOption;let optionindex=index;">
              <small *ngIf="modifier.sommo_quantity > 0">
                {{modifier.sommo_option_name}}<span
                  *ngIf="optionindex !== modifierset.modifierOption.length - 1">,</span>
              </small>
            </span>
          </p>
        </div>
        <div class="col-2">
          <span>{{item.variant[0].variantQty}}</span>
        </div>
        <div class="col-3 text-right">
          <span>{{item.totalPrice.toFixed(2)}}</span>
        </div>
      </div>
    </div>
    <div class="row no-gutters border-top py-2">
      <div class="col text-right">
        <label for="" class="fw-500 mb-0 font-weight-bold-500">Sub Total</label>
      </div>
      <div class="col-3 text-right">
        <label class="mb-0">
          <span>
            <small *ngIf="selectedOrder.Position === 'BACK'">
              {{selectedOrder.Currency}}
            </small>
            {{selectedOrder.saleOrder.orderSubTotal.toFixed(2)}}
            <small *ngIf="selectedOrder.Position === 'FRONT'">
              {{selectedOrder.Currency}}
            </small>
          </span>
        </label>
      </div>
    </div>

    <div class="row no-gutters border-top py-2">
      <div class="col text-right">
        <label for="" class="fw-500 mb-0 font-weight-bold-500">Order Discount</label>
      </div>
      <div class="col-3 text-right">
        <label class="mb-0">
          <span>
            <small *ngIf="selectedOrder.Position === 'BACK'">
              {{selectedOrder.Currency}}
            </small>
            {{selectedOrder.orderDiscount.toFixed(2)}}
            <small *ngIf="selectedOrder.Position === 'FRONT'">
              {{selectedOrder.Currency}}
            </small>
          </span>
        </label>
      </div>
    </div>

    <div class="row" *ngIf="selectedOrder.listcashback">
      <div class="col">
        <div *ngFor="let discount of selectedOrder.listcashback">
          <div class="row no-gutters" *ngIf="discount.ooocd_type === 'REFERRAL_DISCOUNT'">
            <div class="col text-right">
              <span for="" class="font-weight-bold-500">
                {{discount.ooocd_mod_name}}
                <span *ngIf="discount.ooocd_percentage > 0">
                  ({{discount.ooocd_percentage}}%)
                </span>
              </span>
            </div>
            <div class="col-3 text-right">
              <span class="mb-0">
                <small *ngIf="position === 'BACK'">
                  {{currency}}
                </small>
                -{{discount.ooocd_amount.toFixed(2)}}
                <small *ngIf="position === 'FRONT'">
                  {{currency}}
                </small>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row no-gutters border-top py-2" *ngFor="let tax of selectedOrder.ListOrderTax">
      <div class="col text-right">
        <label for="" class="fw-500 mb-0 font-weight-bold-500">{{tax.TaxName}}</label>
      </div>
      <div class="col-3 text-right">
        <label class="mb-0">
          <span>
            <small *ngIf="selectedOrder.Position === 'BACK'">
              {{selectedOrder.Currency}}
            </small>
            {{tax.TaxAmount.toFixed(2)}}
            <small *ngIf="selectedOrder.Position === 'FRONT'">
              {{selectedOrder.Currency}}
            </small>
          </span>
        </label>
      </div>
    </div>
    <div class="row no-gutters border-top py-2" *ngIf="selectedOrder.orderServiceType === 'DINE_IN'">
      <div class="col text-right">
        <label for="" class="fw-500 mb-0 font-weight-bold-500">Service Charges<span *ngIf="selectedOrder.surcharges">({{selectedOrder.surcharges.sosur_surcharge_percentage}}%)</span></label>
      </div>
      <div class="col-3 text-right">
        <label class="mb-0">
          <span>
            <small *ngIf="selectedOrder.Position === 'BACK'">
              {{selectedOrder.Currency}}
            </small>
            {{selectedOrder.saleOrder.surcharge.toFixed(2)}}
            <small *ngIf="selectedOrder.Position === 'FRONT'">
              {{selectedOrder.Currency}}
            </small>
          </span>
        </label>
      </div>
    </div>
    <div class="row no-gutters border-top py-2" *ngIf="selectedOrder.orderServiceType === 'DELIVERY'">
      <div class="col text-right">
        <label for="" class="fw-500 mb-0 font-weight-bold-500">Delivery Charges</label>
      </div>
      <div class="col-3 text-right">
        <label class="mb-0">
          <span>
            <small *ngIf="selectedOrder.Position === 'BACK'">
              {{selectedOrder.Currency}}
            </small>
            {{selectedOrder.saleOrder.delivery_charge.toFixed(2)}}
            <small *ngIf="selectedOrder.Position === 'FRONT'">
              {{selectedOrder.Currency}}
            </small>
          </span>
        </label>
      </div>
    </div>

    <div class="row" *ngIf="selectedOrder.listcashback">
      <div class="col">
        <div *ngFor="let discount of selectedOrder.listcashback">
          <div class="row no-gutters" *ngIf="discount.ooocd_type !== 'REFERRAL_DISCOUNT'">
            <div class="col text-right">
              <span for="" class="font-weight-bold-500">
                {{discount.ooocd_mod_name}}
                <span *ngIf="discount.ooocd_percentage > 0">
                  ({{discount.ooocd_percentage}}%)
                </span>
              </span>
            </div>
            <div class="col-3 text-right">
              <span class="mb-0">
                <small *ngIf="position === 'BACK'">
                  {{currency}}
                </small>
                -{{discount.ooocd_amount.toFixed(2)}}
                <small *ngIf="position === 'FRONT'">
                  {{currency}}
                </small>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row no-gutters border-top py-2">
      <div class="col text-right">
        <label for="" class="fw-500 mb-0 font-weight-bold-500">Total</label>
      </div>
      <div class="col-3 text-right">
        <label for="" class="font-weight-bold mb-0">
          <span>
            <small *ngIf="selectedOrder.Position === 'BACK'">
              {{selectedOrder.Currency}}
            </small>
            {{selectedOrder.ordertotalamount.toFixed(2)}}
            <small *ngIf="selectedOrder.Position === 'FRONT'">
              {{selectedOrder.Currency}}
            </small>
          </span>
        </label>
      </div>
    </div>

    <div class="row no-gutters border-top py-2">
      <div class="col text-right">
        <label for="" class="fw-500 mb-0 font-weight-bold-500">Paid by {{selectedOrder.paidby}}</label>
      </div>
      <div class="col-3 text-right">
        <label for="" class="font-weight-bold mb-0">
          <span>
            <small *ngIf="selectedOrder.Position === 'BACK'">
              {{selectedOrder.Currency}}
            </small>
            {{selectedOrder.ordertotalamount.toFixed(2)}}
            <small *ngIf="selectedOrder.Position === 'FRONT'">
              {{selectedOrder.Currency}}
            </small>
          </span>
        </label>
      </div>
    </div>
    
    <br />
    <div class="row form-group email-div">
      <div class="col-6 input-group input-group-lg pr-0" [formGroup]="emailForm">
        <input type="email" class="form-control " placeholder="youremail@mail.com" formControlName="email"
          [ngClass]="{'has-error': ((emailForm.get('email').touched || emailForm.get('email').dirty) &&  emailForm.get('email').errors)}" />
      </div>
      <div class="col text-right pr-0 pl-0">
        <button
          class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none btn-block rounded btn-sm button-border-radius"
          (click)="onSendEmailClick(selectedOrder)">Send</button>
      </div>
      <div class="col text-center">
        <button class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none btn-block rounded btn-sm"
          (click)="onDownloadPdfClick(selectedOrder)">
          Download
          <!--<i class="far fa-file-pdf fa-lg cursor"></i>-->
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span [ngClass]="{'text-success': invoiceRequest, 'text-danger': !invoiceRequest}">{{invoiceMsg}}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #rating>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Rate Order</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onRatingHide()">
      <i class="fas fa-check"></i>
    </button>
  </div>
  <div class="modal-body">
    <rating [(ngModel)]="rate" [max]="max" [customTemplate]="tt"></rating>
    <pre class="card-block card-header" style="margin:15px 0;">Rate: <b>{{rate}}</b> </pre>
    <ng-template #tt let-i="index" let-v="value">
      <i class="far fa-star fa-2x" *ngIf="!(i < v)"></i>
      <i class="fas fa-star icon-color-gold fa-2x" *ngIf="i < v"></i>
    </ng-template>
    <!-- <div class="row">
      <div class="col">
        <input type="text" class="form-control" placeholder="add tips here" />
      </div>
    </div> -->
  </div>
</ng-template>
<app-loading-component></app-loading-component>
